export default "__VITE_ASSET__4vPGBDOS__"